export default __webpack_public_path__ + "media/images/images/carousel/07-104542854aefd1ec50ffbe6320881f2e.jpg";